export { default } from './PriceCards';



// WEBPACK FOOTER //
// ./src/components/templates/PriceCards/index.js